import { render } from "./ClientSettings.vue?vue&type=template&id=8d0b00fe&scoped=true"
import script from "./ClientSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettings.vue?vue&type=style&index=0&id=8d0b00fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0b00fe"]])

export default __exports__